import { Amplify } from 'aws-amplify';

export const amplifyConfig = {
  Auth: {
    Cognito: {
      userPoolId: import.meta.env.VITE_AWS_USER_POOL_ID,
      userPoolClientId: import.meta.env.VITE_AWS_USER_POOL_WEB_CLIENT_ID,
      region: import.meta.env.VITE_AWS_REGION,
      loginWith: {
        email: true,
      },
    },
  },
  Storage: {
    S3: {
      bucket: import.meta.env.VITE_AWS_S3_BUCKET,
      region: import.meta.env.VITE_AWS_REGION,
    },
  },
};

export function configureAmplify() {
  Amplify.configure(amplifyConfig);
}
